export const obtenerDiasDisponibles = (arrSemana) => {

    let arr = []
    for (let i = 0; i < arrSemana.length; i++) {
        let dia = arrSemana[i]
        if (dia.am || dia.pm) {
            arr.push(i)
        }
    }

    return arr
}